<template>
    <div>
        <div class="item-panel" v-for="(item,index) in list" :key="index">
            <coupon-item :p_info="item" :p_show_button="true" />
        </div>
        <van-empty v-if="list.length===0" description="暂无数据" />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import CouponItem from "./CouponItem";

    export default {
        name: "CouponList",
        components: {CouponItem},
        props:{
            p_action:{          //1未使用列表；2已使用列表，3已失效列表
                type:Number,
                default:0,
                required:true,
            }
        },
        data(){
            return{
                list:[],
                loading:false,
                finished:false,
                refreshing: false,
                load_qty:10,
                finish_text:'',
                detailVisible:false,
                currentInfo:{},
                tagType:'',
                moment:this.$moment,
            }
        },
        methods:{
            ...mapActions([
                'GetUserCouponList',
            ]),
            load_list(){
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                this.loading=true;
                let p={
                    show_count:this.load_qty,
                    mode:this.p_action,
                    uid:this.$store.getters.getLoginUser.id,
                };
                this.GetUserCouponList(p).then(res=>{
                    console.log('done');
                    this.loading=false;
                    this.list=res;
                    // if(this.list.length>10){
                    //     this.finish_text='我是底线';
                    // }
                    // if(this.load_qty>=res.total){
                    //     this.finished=true;
                    // }else{
                    //     this.load_qty +=10;
                    // }
                });
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;

                // 重新加载数据
                this.load_list();
            },
        },
        mounted() {
            document.body.style.backgroundColor='#F3F4F5';  //设置整页背景色
            this.load_list();
        }
    }
</script>

<style lang="scss" scoped>
</style>
